// HospitalPage.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import StickyHeader from "../../components/StickyHeader";
import StickyFooter from "../../components/StickyFooter";
import "../../css/HumanResources.css";
function HumanResources() {
  useEffect(() => {
    AOS.init({
      duration: 800, // 缩短动画时间使响应更快
      once: false, // 允许重复触发动画
      offset: 100,
      easing: "ease-out-cubic", // 添加缓动效果
      delay: 0,
      mirror: true, // 页面滚动时反向动画
    });
  }, []);
  return (
    <div className="home-container">
      <StickyHeader />
      <div className="main-content">
        <div
          style={{
            width: "100%",
            height: "700px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={`${process.env.PUBLIC_URL}/imgs/banneroone.png`}
            alt=""
          />
          <div className='co-textylx' style={{ color: "black" }}>欢迎加入</div>


          <div className='co-textsylx'>
            本公司是一家集研发、设计、制造及储能电站投资和开发、服务于一体的高新技术企业。
            欢迎并期待您的加入！
          </div>

        </div>
        <div style={{ minHeight: "800px" }}>
          {/* 第一个盒子 - 产 品 介 绍 */}
          <div className="top11 animated-section">
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h1">人 才 战 略</span>
                    <p>
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                        alt=""
                        className="dot-animation"
                      />
                    </p>
                  </div>
                  <div className="boxno1">
                  <div
                      // className="rit"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/配图1.png`}
                        alt=""
                        className="image-hover"
                        style={{ paddingTop:"15px", paddingLeft:"50px", paddingRight:"50px"}} // Adjust image size as necessar
                      />
                    </div>
                   <div>
                      <span className="textnoe1">
                        <p>&emsp;&emsp;人才是公司核心竞争力的基石，更是驱动公司高质量发展的核心引擎。公司始终坚持“人才驱动发展，战略引领未来”的核心导向，将人才战略贯穿于企业发展全周期，构建“引才、育才、用才、留才”一体化人才生态体系，为公司战略落地与长远发展提供坚实的人才保障。</p>
                        <p>
                        &emsp;&emsp;公司人才战略以“精准引才、系统育才、科学用才、文化留才”为四大核心方向，聚焦核心业务领域与未来发展布局，定向吸纳行业顶尖人才与潜力骨干；搭建分层分类的人才培养体系，赋能员工全职业周期成长；建立以价值创造为核心的用人机制，实现人岗精准匹配与人才价值最大化；营造开放包容、赋能创新的企业文化，让人才在实现个人价值的同时，与公司共成长、共成就。
                        </p>
                        <p>
                        &emsp;&emsp;未来，公司将持续深化人才战略，不断优化人才发展环境，强化人才资源整合与赋能，致力于打造一支结构合理、素质优良、富有活力的核心人才队伍，为公司深耕行业、开拓创新、实现战略目标注入源源不断的人才动力。
                        </p>
                      </span>
                      <div className="bottonm">
                        <img
                          src={`${process.env.PUBLIC_URL}/imgs/人才战略图标.png`}
                          alt=""
                        />
                      </div>
                      
                    </div>
                  
                    
                  </div>

                  {/* <div className="boxno1" >

                    <div
                      className="rit"
                      data-aos="fade-right"
                      data-aos-delay="200"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/配图2.png`}
                        alt=""
                        className="image-hover"
                      />
                    </div>
                    <div className="lef" data-aos="fade-left">
                      <span className="textnoe">
                        人才是企业的根本，才兴则财量。
                        选对人。不重文凭重水平，不重学历重能力，
                        合适就是最好。
                        育好人。玉不琢，不成器；人才的关键靠培育。
                        用好人。人岗匹配，把合适的人放在合适的位置
                        ，量才而用，人尽其才，才尽其用。
                        留住人，平台留人，待遇留人，环境留人，感情留人。
                      </span>
                      <div className="bottonm">
                        <img
                          src={`${process.env.PUBLIC_URL}/imgs/人才战略图标.png`}
                          alt=""
                        />
                      </div>
                    </div>

                  </div> */}
                </div>
              </div>
            </Container>
          </div>

          {/* 第二个盒子 - 产品优势 */}
          <div className='top6'>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>加 入 我 们</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='one'>
                    <div className="box11">
                      <div className="seb"

                      >
                        {/* <a href="https://m.zhipin.com/mpa/html/weijd/weijd-job/c2fbc20e86ad7c2103Jz2dq6FVdW?date8=20251203&sid=qr_self_jd&openWeapp=1">11111</a> */}
                        <div className="No1">
                          <div className="hp">linux驱动开发工程师</div>
                          <div className="jop">
                            <span className="nei">3-5年</span>
                            <span className="nei">本科</span>
                          </div>
                          <div className="No2">
                            <img
                              src={`${process.env.PUBLIC_URL}/imgs/头像.png`}
                              alt=""
                            />
                            <span>张女士 行政人事</span>
                            <span>合肥肥西县 高新区</span>
                          </div>
                        </div>

                      </div>
                      <div className="seb">
                        <div className="No1">
                          <div className="hp">储能运营工程师</div>
                          <div className="jop">
                            <span className="nei">1-3年</span>
                            <span className="nei">本科</span>
                          </div>
                          <div className="No2">
                            <img
                              src={`${process.env.PUBLIC_URL}/imgs/头像.png`}
                              alt=""
                            />
                            <span>张女士 行政人事</span>
                            <span>合肥肥西县 高新区</span>
                          </div>
                        </div>

                      </div>
                      <div className="seb">
                        <div className="No1">
                          <div className="hp">高级嵌入式软件工程师</div>
                          <div className="jop">
                            <span className="nei">3-5年</span>
                            <span className="nei">本科</span>
                          </div>
                          <div className="No2">
                            <img
                              src={`${process.env.PUBLIC_URL}/imgs/头像.png`}
                              alt=""
                            />
                            <span>张女士 行政人事</span>
                            <span>合肥肥西县 高新区</span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>



        </div>
      </div>

      <StickyFooter />
    </div>
  );
}

export default HumanResources;
